/**
 * Configuración global de especialidades
 * Define las especialidades que deben ser excluidas de las listas
 */

// Especialidades que NO deben aparecer en las listas de selección
export const ESPECIALIDADES_EXCLUIDAS = [
    'enfermera',
    'administrador',
    'bodega'
];

// Función para filtrar especialidades excluidas
export const filtrarEspecialidades = (especialidades) => {
    return especialidades.filter(especialidad => 
        !ESPECIALIDADES_EXCLUIDAS.includes(especialidad.codigo)
    );
};

// Función para verificar si una especialidad está excluida
export const esEspecialidadExcluida = (codigoEspecialidad) => {
    return ESPECIALIDADES_EXCLUIDAS.includes(codigoEspecialidad);
};


 